import { DeleteFilled, DragOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  Form,
  Input,
  Popconfirm,
  Select,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import React from 'react';

import { getAlphabet } from '../../library/util';
import DroppableRateClass from './DroppableRateClass';

const SortableRateClassCard = ({
  assignedVehicles,
  classification,
  deletableClass,
  editedName,
  index,
  isEditing,
  isRemoving,
  onClassNameChange,
  onDelete,
  onDeleteCancel,
  onDeleteClick,
  onRemoveVehicle,
  vehicles,
}) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    data: {
      type: 'class',
    },
    disabled: !isEditing,
    id: classification.id,
  });

  const style = {
    // Hide the source while DragOverlay follows the pointer
    opacity: isDragging ? 0 : 1,
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      className="class-list__rate-class-container"
      style={style}
    >
      <div className="class-list__rate-class-header">
        <Space>
          {isEditing && (
            <DragOutlined
              className="class-list__class-drag-handle"
              style={{ color: 'rgba(0, 0, 0, 0.45)', cursor: 'grab' }}
              {...attributes}
              {...listeners}
            />
          )}
          {isEditing ? (
            <Input
              placeholder={`Class ${getAlphabet(index)}`}
              size="middle"
              status={!editedName?.trim() ? 'error' : undefined}
              style={{ width: 155 }}
              value={editedName || ''}
              onChange={(e) => onClassNameChange(classification.id, e.target.value)}
            />
          ) : (
            <span>
              {classification.name}{' '}
              {classification.name !== `Class ${getAlphabet(index)}` && (
                <Typography.Text type="secondary">
                  (Class {getAlphabet(index)})
                </Typography.Text>
              )}
            </span>
          )}
          {isEditing && (
            <Popconfirm
              okButtonProps={{ loading: isRemoving }}
              open={deletableClass?.id === classification.id}
              title="Are you sure to delete this Rate Class?"
              onCancel={onDeleteCancel}
              onConfirm={onDelete}
            >
              <Tooltip title="Delete Rate Class">
                <DeleteFilled
                  style={{ color: '#ff4d4f', cursor: 'pointer' }}
                  onClick={() => onDeleteClick(classification)}
                />
              </Tooltip>
            </Popconfirm>
          )}
        </Space>
      </div>
      <Form.Item noStyle name={classification.id}>
        <DroppableRateClass
          assignedVehicles={assignedVehicles}
          classification={classification}
          isEditing={isEditing}
          vehicles={vehicles}
          onRemoveVehicle={onRemoveVehicle}
        />
        <Select
          className="class-list__vehicle-select"
          disabled={!isEditing}
          mode="multiple"
          placeholder="Vehicle Types"
          style={{ display: 'none' }}
        >
          {vehicles.map((vehicle) => (
            <Select.Option key={vehicle.id} value={vehicle.id}>
              {vehicle.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
};

export default SortableRateClassCard;
